import React from "react";
import { Link } from "react-router-dom";

import LoginModal from "../Modals/LoginModal";
import RegisterModal from "../Modals/RegisterModal";
import OtpConfirmLoginModal from "../Modals/OtpConfirmLoginModal";
import ForgotPasswordModal from "../Modals/ForgotPasswordModal";
import OtpValidateModal from "../Modals/OtpValidateModal";
import ResetPassowordModal from "../Modals/ResetPassowordModal";
import CongratsModal from "../Modals/CongratsModal";
import { assetImages } from "constants";

const Footer = () => {
  return (
    <footer className="ftr_sec bg_light_ylw">
      <div className="container">
        <div className="ftr_top d-flex align-items-center justify-content-between gap-2">
          <div className="ftr_top_left d-flex align-items-center gap-2 ">
            <div className="ftr_logo">
              <Link to="/">
                <img src={assetImages.homeLogo} alt="" />
              </Link>
            </div>
            <div className="ftr_links position-relative">
              <ul className="d-flex align-items-center gap-2 list_style_none">
                <li>
                  <Link
                    to="/agenda"
                    className="fs-md text-primary text-uppercase fw-bold"
                  >
                    Agenda
                  </Link>
                </li>
                <li>
                  <Link
                    to="/speakers"
                    className="fs-md text-primary text-uppercase fw-bold"
                  >
                    Speakers
                  </Link>
                </li>
                <li>
                  <Link
                    to="/partners"
                    className="fs-md text-primary text-uppercase fw-bold"
                  >
                    Partners
                  </Link>
                </li>
                <li>
                  <Link
                    to="/community"
                    className="fs-md text-primary text-uppercase fw-bold"
                  >
                    Community
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="ftr_top_lright">
            <ul className="d-flex list_style_none align-items-center gap-3">
              <li>
                <Link to="#">
                  <img src={assetImages.appStoreImg} alt="" />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <img src={assetImages.playStoreImg} alt="" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="ftr_bttm d-flex align-items-center justify-content-between">
          <div className="privacy_links">
            <ul className="d-flex gap-2 align-items-center list_style_none">
              <li>
                <Link to="#" className="fs-sm text-primary">
                  Terms of Use{" "}
                </Link>
              </li>
              <li>
                <Link to="#" className="fs-sm text-primary">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          <div className="copyright">
            <p>Copyright 2024 International Startup Event</p>
          </div>
        </div>
      </div>

      <LoginModal />

      <RegisterModal />

      <OtpConfirmLoginModal />

      <ForgotPasswordModal />

      <OtpValidateModal />

      <ResetPassowordModal />

      <CongratsModal />
    </footer>
  );
};

export default Footer;
